import {
  FaAngleRight,
  FaExclamation,
  FaExpandAlt,
  FaRegEnvelope,
  FaRegUser,
} from "react-icons/fa";
import "./Footer.scss";
import { TfiAngleDoubleRight } from "react-icons/tfi";
import { BsFillMegaphoneFill, BsTelephoneFill } from "react-icons/bs";
import { Link } from "react-router-dom";

const FooterLinks = () => {
  const contactEmail = process.env.REACT_APP_CONTACT_EMAIL;
  const contactPhone = process.env.REACT_APP_CONTACT_PHONE;
  return (
    <div className="footer">
      <div className="footerTop">
        <div className="footerTopWrapper">
          <div className="item">
            <div className="title">
              <h2 className="h4">About Us</h2>
              <FaExclamation size={18} />
            </div>

            <div className="about">
              <div className="content">
                <p>
                  Welcome to BeckyNews! We’re a team of passionate writers,
                  creators, and storytellers dedicated to bringing you fresh,
                  insightful, and engaging content. Our mission is to explore a
                  wide range of topics from lifestyle and wellness to
                  technology, travel, and everything in between. Whether you're
                  looking for practical tips, inspiring stories, or the latest
                  trends, we’ve got you covered.
                </p>
              </div>
              <div className="action">
                <Link className="btn-link">
                  Read More
                  <TfiAngleDoubleRight size={12} />
                </Link>
              </div>
              <ul>
                {/* <li>
                  <FaMapMarkerAlt size={15} className="icon" />
                  <span>Street Address, USA</span>
                </li> */}
                <li>
                  <FaRegEnvelope size={15} className="icon" />
                  <span>{contactEmail}</span>
                </li>
                <li>
                  <BsTelephoneFill size={15} className="icon" />
                  <span>{contactPhone}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="item">
            <div className="title">
              <h2 className="h4">Usefull Info Links</h2>
              <FaExpandAlt size={18} />
            </div>
            <div className="links">
              <ul className="nav">
                <li>
                  <Link to="/privacy-policy">
                    <FaAngleRight />
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to={"https://sabalistore.com/"} target="_blank">
                    <FaAngleRight />
                    Shop
                  </Link>
                </li>
                <li>
                  <Link>
                    <FaAngleRight />
                    Forums
                  </Link>
                </li>
                <li>
                  <Link>
                    <FaAngleRight />
                    Top News of This Week
                  </Link>
                </li>
                <li>
                  <Link to="/register">
                    <FaAngleRight />
                    Sign Up
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="item">
            <div className="title">
              <h2 className="h4">Advertisement</h2>
              <BsFillMegaphoneFill size={18} />
            </div>
            <div className="links">
              <ul className="nav">
                <li>
                  <Link>
                    <FaAngleRight />
                    Post an Ad
                  </Link>
                </li>
                <li>
                  <Link>
                    <FaAngleRight />
                    Ads Renew
                  </Link>
                </li>
                <li>
                  <Link>
                    <FaAngleRight />
                    Price of Advertisement
                  </Link>
                </li>
                <li>
                  <Link>
                    <FaAngleRight />
                    Ads Closed
                  </Link>
                </li>
                <li>
                  <Link>
                    <FaAngleRight />
                    Trial Ads
                  </Link>
                </li>
                <li>
                  <Link>
                    <FaAngleRight />
                    Ad Making
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="item">
            <div className="title">
              <h2 className="h4">Career</h2>
              <FaRegUser />
            </div>
            <div className="links">
              <ul className="nav">
                <li>
                  <Link>
                    <FaAngleRight />
                    Available Post
                  </Link>
                </li>
                <li>
                  <Link>
                    <FaAngleRight />
                    Career Details
                  </Link>
                </li>
                <li>
                  <Link>
                    <FaAngleRight />
                    How to Apply?
                  </Link>
                </li>
                <li>
                  <Link>
                    <FaAngleRight />
                    Freelance Job
                  </Link>
                </li>
                <li>
                  <Link>
                    <FaAngleRight />
                    Be a Member
                  </Link>
                </li>
                <li>
                  <Link>
                    <FaAngleRight />
                    Apply Now
                  </Link>
                </li>
                <li>
                  <Link>
                    <FaAngleRight />
                    Send Your Resume
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FooterLinks;
